var _defs, _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveToVng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c853;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.29,99.16a14,14,0,0,0,.75-4.57V36.8a20.13,20.13,0,0,0-5.23-14.15c-2.67-2.92-7.48-6.35-15.35-6.61h0l-.95,0H28.28C15.81,16,8.35,26.15,8.35,35.94V47.06A13.51,13.51,0,0,0,21.86,60.57H39.32a2.48,2.48,0,0,0,0,.39V178.24c0,15.19,10.86,23.77,21.08,24.14h45.33a13.72,13.72,0,0,0,7.59-2.27,69,69,0,1,0,80-101ZM21.86,47.06V35.94s0-6.41,6.42-6.41H152.75c-7.48,3.92-3.64,17.53-3.64,17.53ZM172.65,220.47A55.48,55.48,0,1,1,228.14,165,55.47,55.47,0,0,1,172.65,220.47Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "209.02 152.06 209.02 177.93 185.6 177.93 185.6 201.36 159.73 201.36 159.73 177.93 136.3 177.93 136.3 152.06 159.73 152.06 159.73 128.63 185.6 128.63 185.6 152.06 209.02 152.06"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveToVng);
export default __webpack_public_path__ + "static/media/saveToVNG.eb0c07d7.svg";
export { ForwardRef as ReactComponent };